import React from 'react';
import { Plus } from 'lucide-react';
import { addOns } from '../mock';

export const AddOns = () => {
  return (
    <section className="py-16 bg-[#0B7CB5]/5">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              <span className="text-[#0B7CB5]">Add-On</span> Services
            </h3>
            <p className="text-lg text-gray-600">
              Customize your cleaning with these additional services
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {addOns.map((addon, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 hover:-translate-y-1 group"
              >
                <div className="flex-shrink-0">
                  <div className="w-8 h-8 bg-[#5CC4E8]/20 rounded-full flex items-center justify-center group-hover:bg-[#0B7CB5] transition-colors duration-200">
                    <Plus className="w-5 h-5 text-[#0B7CB5] group-hover:text-white transition-colors duration-200" />
                  </div>
                </div>
                <span className="text-gray-800 font-medium">{addon}</span>
              </div>
            ))}
          </div>

          <p className="text-center text-gray-600 mt-8 text-sm">
            Add-ons can be included when you request your quote
          </p>
        </div>
      </div>
    </section>
  );
};